import sass_tech from './img/sass.svg';
import tailwind_tech from './img/tailwind-css.svg';
import wordpress_tech from './img/wordpress.svg'; 
import html_tech from './img/html.svg'; 
import react_tech from './img/react.svg'; 
import css_tech from './img/css.svg'; 
import js_tech from './img/js.svg';
import bootstrap_tech from './img/bootstrap.svg';
import figma_tech from './img/figma.svg';
import github_tech from './img/github.svg';
import vscode_tech from './img/vs-code.svg';
import jenkins_tech from './img/jenkins.svg';

const techLogos = [
    { src: html_tech, alt: "HTML" },
    { src: css_tech, alt: "CSS" },
    { src: js_tech, alt: "JavaScript" },
    { src: react_tech, alt: "React" },
    { src: sass_tech, alt: "Sass" },
    { src: tailwind_tech, alt: "Tailwind CSS" },
    { src: bootstrap_tech, alt: "Bootstrap" },
  ];

  const toolsLogos = [
    { src: wordpress_tech, alt: "WordPress" },
    { src: figma_tech, alt: "Figma" },
    { src: github_tech, alt: "GitHub" },
    { src: vscode_tech, alt: "Visual Studio Code" },
    { src: jenkins_tech, alt: "Jenkins" },
  ];
  
  export { techLogos, toolsLogos }; 